
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("2uohk", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");

/**
 * @generated SignedSource<<90a301b48628f89c4216af8ea5c0e42e>>
 * @relayHash 54bc6313ef4580fd0d1d858b0cd8904a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0365bc3be859c7e67a127713b625b50dc916f847d76a49601135535ae8e80f4c
const $802c078d935caa92$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "orgId"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "after",
                    "variableName": "after"
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                },
                {
                    "kind": "Variable",
                    "name": "orgId",
                    "variableName": "orgId"
                }
            ],
            "concreteType": "AdminAccessUrlConnection",
            "kind": "LinkedField",
            "name": "admin_accessUrls",
            "plural": false,
            "selections": [
                {
                    "concreteType": "AdminAccessUrlEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "AdminAccessUrlV2",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "resourceUrl"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "expirationDate"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "url"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "status"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "endCursor"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasNextPage"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "startCursor"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useQueryInvitationUrlQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useQueryInvitationUrlQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "54bc6313ef4580fd0d1d858b0cd8904a",
            "id": "0365bc3be859c7e67a127713b625b50dc916f847d76a49601135535ae8e80f4c",
            "metadata": {},
            "name": "useQueryInvitationUrlQuery",
            "operationKind": "query",
            "text": "query useQueryInvitationUrlQuery($orgId:ID!,$after:String,$first:Int){admin_accessUrls(orgId:$orgId,after:$after,first:$first){edges{node{id,resourceUrl,expirationDate,url,status}},pageInfo{endCursor,hasNextPage,startCursor}}}"
        }
    };
}();
$802c078d935caa92$var$node.hash = "c341c045655f91003362243763c690c2";
var $802c078d935caa92$export$2e2bcd8739ae039 = $802c078d935caa92$var$node;



var $eSUdr = parcelRequire("eSUdr");





var $j1Ss3 = parcelRequire("j1Ss3");


var $gKr8t = parcelRequire("gKr8t");


var $9wGTI = parcelRequire("9wGTI");


var $jMyy4 = parcelRequire("jMyy4");


var $8Lx5S = parcelRequire("8Lx5S");


var $bQm3c = parcelRequire("bQm3c");


var $7Sm4c = parcelRequire("7Sm4c");


var $1uFM6 = parcelRequire("1uFM6");


var $1ytiN = parcelRequire("1ytiN");

/**
 * CC GraphQL query abstraction for fetching invitation URLs
 */ const $3b5b1d9e3bdf3647$var$useCCInvitationUrlQuery = (skipQuery, isLicensed, isAdmin)=>{
    const { data: data, loading: loading, error: error } = (0, $j1Ss3.useQuery)(/** @schema cc */ (0, $eSUdr.default)`query useQueryInvitationUrlCreateInvitationUrlQuery{invitationUrls{urls{id url status}}}`, {
        skip: skipQuery || !isLicensed || !isAdmin || (0, $9wGTI.fg)('confluence_frontend_use_agg_invite_url')
    });
    const existingInviteLink = data?.invitationUrls?.urls?.[0]?.url || '';
    const existingInviteLinkStatus = data?.invitationUrls?.urls?.[0]?.status;
    return {
        existingInviteLink: existingInviteLink,
        existingInviteLinkStatus: existingInviteLinkStatus,
        loading: loading,
        error: error
    };
};
/**
 * AGG query abstraction with automatic pagination to find matching invitation URL
 */ const $3b5b1d9e3bdf3647$var$FINISHED_NO_MATCH = 'FINISHED_NO_MATCH';
const $3b5b1d9e3bdf3647$var$useAGGInvitationUrlQuery = (skipQuery, isLicensed, isAdmin)=>{
    // Single state: null = still searching, AccessUrlNode = found match, FINISHED_NO_MATCH = finished but no match
    const [searchResult, setSearchResult] = (0, $42omo.useState)(null);
    const { orgId: orgId } = (0, $bQm3c.useSessionData)();
    const { data: aggData, loading: aggLoading, error: aggError, refetch: refetch } = (0, $jMyy4.useQueryInterop)(/** @schema agg */ (0, $802c078d935caa92$export$2e2bcd8739ae039), {
        skip: skipQuery || !isLicensed || !isAdmin || !orgId || !(0, $9wGTI.fg)('confluence_frontend_use_agg_invite_url'),
        variables: {
            orgId: orgId || '',
            first: 50
        },
        // Temporary fix to use AGG client for swapping invitation url query to use AGG, making this independent of the cc-agg-migration-use-agg-endpoint FG
        // TODO: Remove this once the cc-agg-migration-use-agg-endpoint FG is rolled out and we're at the stage of deprecating Apollo.
        client: (0, $gKr8t.getAGGClient)()
    });
    // Reset search state when orgId changes
    (0, $42omo.useEffect)(()=>{
        setSearchResult(null);
    }, [
        orgId
    ]);
    // Handle pagination and matching logic
    (0, $42omo.useEffect)(()=>{
        // Skip if no data, still loading, or already finished (found match or finished searching)
        if (!aggData || aggLoading || searchResult !== null) return;
        const match = $3b5b1d9e3bdf3647$var$findMatchingNode(aggData.admin_accessUrls.edges);
        if (match) {
            setSearchResult(match);
            return;
        }
        // If no match and has more pages, fetch next page
        const { hasNextPage: hasNextPage, endCursor: endCursor } = aggData.admin_accessUrls.pageInfo;
        if (hasNextPage && endCursor && refetch) refetch({
            orgId: orgId || '',
            after: endCursor,
            first: 50
        });
        else setSearchResult($3b5b1d9e3bdf3647$var$FINISHED_NO_MATCH);
    }, [
        aggData,
        aggLoading,
        orgId,
        refetch,
        searchResult
    ]);
    const matchedNode = searchResult !== null && searchResult !== $3b5b1d9e3bdf3647$var$FINISHED_NO_MATCH ? searchResult : null;
    return {
        existingInviteLink: matchedNode?.url || '',
        existingInviteLinkStatus: matchedNode?.status,
        loading: aggLoading || searchResult === null,
        error: aggError
    };
};
const $3b5b1d9e3bdf3647$export$834f62bb15aa25c7 = ({ skipQuery: skipQuery = false })=>{
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const { isSiteAdmin: isSiteAdmin, loading: spaViewContextLoading, error: spaViewContextError } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const isAdmin = isSiteAdmin && !spaViewContextLoading && !spaViewContextError;
    // CC query abstraction
    const ccResult = $3b5b1d9e3bdf3647$var$useCCInvitationUrlQuery(skipQuery, isLicensed, isAdmin);
    // AGG query abstraction with pagination
    const aggResult = $3b5b1d9e3bdf3647$var$useAGGInvitationUrlQuery(skipQuery, isLicensed, isAdmin);
    // Select result based on feature flag (inline feature gate call)
    const result = (0, $9wGTI.fg)('confluence_frontend_use_agg_invite_url') ? aggResult : ccResult;
    // Handle error marking
    (0, $42omo.useEffect)(()=>{
        if (result.error && (0, $1uFM6.isUnauthorizedError)(result.error)) (0, $7Sm4c.markErrorAsHandled)(result.error);
    }, [
        result.error
    ]);
    return result;
};
/**
 * Find matching invitation URL node by comparing hostname from resourceUrl with current page hostname
 */ const $3b5b1d9e3bdf3647$var$findMatchingNode = (edges)=>{
    const currentHostname = typeof window !== 'undefined' ? window.location.hostname : null;
    for (const edge of edges){
        let resourceHostname = null;
        try {
            resourceHostname = new URL(edge.node.resourceUrl).hostname;
        } catch  {
            resourceHostname = null;
        }
        if (resourceHostname === currentHostname) return edge.node;
    }
    return null;
};


/**
 * @generated SignedSource<<430b2acdf26caa3eb59bfb6d354eea0d>>
 * @relayHash 01d3cc20dc89cc4f71cd5667af6cdadb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 75dc707963ac426371ab9ef03162af1f51d9bd61c5d5e9deb993cedc848c247d
const $90acfd3ecfd0c05f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "resourceAri"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "resourceAri",
                    "variableName": "resourceAri"
                }
            ],
            "concreteType": "AdminAccessUrlCreationResponsePayload",
            "kind": "LinkedField",
            "name": "admin_createAccessUrl",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "AdminAccessUrlV2",
                    "kind": "LinkedField",
                    "name": "accessUrl",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "url"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useCreateInvitationUrlMutation",
            "selections": v2 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useCreateInvitationUrlMutation",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "01d3cc20dc89cc4f71cd5667af6cdadb",
            "id": "75dc707963ac426371ab9ef03162af1f51d9bd61c5d5e9deb993cedc848c247d",
            "metadata": {},
            "name": "useCreateInvitationUrlMutation",
            "operationKind": "mutation",
            "text": "mutation useCreateInvitationUrlMutation($resourceAri:ID!){admin_createAccessUrl(resourceAri:$resourceAri){__typename,accessUrl{__typename,id,url}}}"
        }
    };
}();
$90acfd3ecfd0c05f$var$node.hash = "6f8e6846d2c3a22ff2d39c54fb28cc9b";
var $90acfd3ecfd0c05f$export$2e2bcd8739ae039 = $90acfd3ecfd0c05f$var$node;












var $kYvrE = parcelRequire("kYvrE");








var $308Wd = parcelRequire("308Wd");










const $9d434232f127a7b6$export$27640c56e4bed0dd = ()=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [aggCalled, setAggCalled] = (0, $42omo.useState)(false);
    // CC mutation (legacy)
    const [createNewInviteLinkCC, { data: ccData, loading: ccLoading, error: ccError, called: ccCalled }] = (0, $j1Ss3.useMutation)(/** @schema cc */ (0, $eSUdr.default)`mutation useCreateInvitationUrlCreateInvitationMutation{createInvitationUrl{id url}}`);
    const [createNewInviteLinkAGG, { data: aggData, loading: aggLoading, error: aggError }] = (0, $308Wd.useMutationInterop)(/** @schema agg */ (0, $90acfd3ecfd0c05f$export$2e2bcd8739ae039), /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ // Temporary fix to use AGG client for swapping invitation url mutation to use AGG, making this independent of the cc-agg-migration-use-agg-endpoint FG
    // TODO: Remove this once the cc-agg-migration-use-agg-endpoint FG is rolled out and we're at the stage of deprecating Apollo.
    {
        client: (0, $gKr8t.getAGGClient)()
    });
    const error = (0, $9wGTI.fg)('confluence_frontend_use_agg_invite_url') ? aggError : ccError;
    (0, $42omo.useEffect)(()=>{
        if (error) {
            if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        }
    }, [
        error
    ]);
    if ((0, $9wGTI.fg)('confluence_frontend_use_agg_invite_url')) return {
        createNewInviteLink: async ()=>{
            setAggCalled(true);
            const siteAri = cloudId ? (0, $kYvrE.ConfluenceSiteAri).create({
                siteId: cloudId
            }).toString() : '';
            return createNewInviteLinkAGG({
                variables: {
                    resourceAri: siteAri
                }
            });
        },
        newInviteLink: aggData?.admin_createAccessUrl?.accessUrl?.url,
        loading: aggLoading,
        error: aggError,
        called: aggCalled
    };
    return {
        createNewInviteLink: createNewInviteLinkCC,
        newInviteLink: ccData?.createInvitationUrl?.url,
        loading: ccLoading,
        error: ccError,
        called: ccCalled
    };
};


/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $5e47882eb43da044$export$7d32434dce2c8cf0 = /*#__PURE__*/ function(InvitationUrlsStatus) {
    InvitationUrlsStatus["ACTIVE"] = "ACTIVE";
    InvitationUrlsStatus["DELETED"] = "DELETED";
    InvitationUrlsStatus["EXPIRED"] = "EXPIRED";
    return InvitationUrlsStatus;
}({});


const $257c04334e5a82b8$export$e8f5b5377c65c712 = ({ skip: skip, allowGenerateNewLink: allowGenerateNewLink, source: source = 'unknown' })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const hasTrackedUsage = (0, $42omo.useRef)(false);
    const { existingInviteLink: existingInviteLink, existingInviteLinkStatus: existingInviteLinkStatus, loading: queryInviteLoading, error: queryInviteError } = (0, $3b5b1d9e3bdf3647$export$834f62bb15aa25c7)({
        skipQuery: skip
    });
    const { createNewInviteLink: createNewInviteLink, newInviteLink: newInviteLink, error: createInviteError, loading: createInviteLoading, called: createInviteCalled } = (0, $9d434232f127a7b6$export$27640c56e4bed0dd)();
    // Track hook usage on mount
    (0, $42omo.useEffect)(()=>{
        if (!hasTrackedUsage.current) {
            hasTrackedUsage.current = true;
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'used',
                    actionSubject: 'inviteLinkHook',
                    source: source,
                    attributes: {
                        skip: skip ?? false,
                        allowGenerateNewLink: allowGenerateNewLink ?? false
                    }
                }
            }).fire();
        }
    }, [
        createAnalyticsEvent,
        source,
        skip,
        allowGenerateNewLink
    ]);
    (0, $42omo.useEffect)(()=>{
        // If we have an existing invite link (after fetching) and if it is expired, create a new one
        if (!skip && !queryInviteLoading && !queryInviteError && (allowGenerateNewLink && !existingInviteLink || existingInviteLinkStatus === (0, $5e47882eb43da044$export$7d32434dce2c8cf0).EXPIRED) && !createInviteCalled) {
            // Track when creating a new invite link
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'inviteLinkCreated',
                    actionSubject: 'inviteLinkHook',
                    source: source,
                    attributes: {
                        reason: existingInviteLinkStatus === (0, $5e47882eb43da044$export$7d32434dce2c8cf0).EXPIRED ? 'expired' : 'noExistingLink'
                    }
                }
            }).fire();
            createNewInviteLink();
        }
    }, [
        skip,
        queryInviteLoading,
        createNewInviteLink,
        createInviteCalled,
        queryInviteError,
        allowGenerateNewLink,
        existingInviteLink,
        existingInviteLinkStatus,
        source,
        createAnalyticsEvent
    ]);
    const inviteLink = existingInviteLinkStatus === (0, $5e47882eb43da044$export$7d32434dce2c8cf0).ACTIVE && existingInviteLink || newInviteLink;
    const error = queryInviteError || createInviteError;
    const loading = queryInviteLoading || createInviteLoading;
    return {
        inviteLink: inviteLink,
        error: error,
        loading: loading
    };
};
module.exports["useInviteLink"] = $257c04334e5a82b8$export$e8f5b5377c65c712;

});


//# sourceMappingURL=LivePageComponent.7385e578.js.map
